import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
// import PropTypes from "prop-types";
import CancelIcon from "@mui/icons-material/Cancel";
import {
  Collapse,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Typography
} from "@material-ui/core";
import { Formik, Form, FieldArray } from "formik";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
import Upload from "../../../components/Upload";
import { uploadToS3 } from "../../../utils/S3";
import styles from "./ImportQuiz.module.scss";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import Input from "../../../components/Input";
import { showHideSnackbar } from "../../../store/Snackbar/actions";
import {
  importQuizzesToBookRequest,
  setupQuizzesToBookRequest,
  setupQuizzesToBookResponce
} from "../../../store/Quizzes/actions";
import ErrorIcon from "@mui/icons-material/Error";
import Button from "../../../components/Button";
import CustomSelect from "../../../components/Select";
import { useTheme } from "@material-ui/core";
import { formatOptions } from "../../../utils/Helpers";
import { getBooksRequest } from "../../../store/Books/actions";
import messages from "../../../assets/locale/messages";
import { validtionOfSubmit } from "./validation";
import { showHideLoader } from "../../../store/Loader/actions";

function ImportQuiz() {
  const formRef = useRef();
  const uploadAllImagesRef = useRef();
  const uploadQuestionRef = useRef(null);
  const uploadAnswerRef = useRef(null);
  const uploadRef = useRef(null);
  const theme = useTheme();
  const dispatch = useDispatch();
  const [book_id, setBookId] = useState(null);
  const lang = useSelector((state) => state.locale.lang);

  const {
    buttons: { submit },
    quizzes: {
      importQuizzes: {
        title,
        note,
        uploadFile,
        points,
        totalPoints,
        uploadQImages,
        issue
      }
    }
  } = messages[lang];
  const {
    quizzes: { importedQuizzes }
  } = useSelector((state) => state);
  const books = useSelector((state) => state.books.list);

  const handleChange = async (event) => {
    try {
      let file = event.target.files[0];
      const validTypes = [
        "text/csv",
        "application/vnd.ms-excel",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      ];
      if (file && !validTypes.includes(file.type)) {
        dispatch(
          showHideSnackbar({
            type: "error",
            isOpen: true,
            message: "Please select a valid CSV or Excel file"
          })
        );
        event.target.value = "";
        return;
      }
      if (book_id) {
        const formData = new FormData();
        formData.append("file", file);
        formData.append("book_id", book_id);

        await dispatch(setupQuizzesToBookRequest(formData));
      }
      // Clear the input value to allow selecting the same file again
      uploadRef.current.value = null;
    } catch (error) {
      console.error("Error sending data:", error);
    }
  };

  const [openCollaps, setOpenCollaps] = useState({});
  const handleOpenCollaps = (index) => {
    setOpenCollaps((prev) => ({
      ...prev,
      [index]: !prev[index]
    }));
  };

  const handleImportQuizzes = () => {
    uploadRef.current.click();
  };

  async function handleUploadSingleImage(
    e,
    index,
    qIndex,
    AIndex,
    type
  ) {
    let file = e?.target?.files[0];
    if (file) {
      if (file?.type?.includes("image")) {
        let url = URL.createObjectURL(file);
        let objFile = { file, url };

        if (type == "question") {
          formRef.current.setFieldValue(
            `[${index}].questions_attributes[${qIndex}].image_url`,
            objFile
          );
          uploadQuestionRef.current.value = null;
        } else if (type == "answer") {
          formRef.current.setFieldValue(
            `[${index}].questions_attributes[${qIndex}].answer_choices_attributes[${AIndex}].image_url`,
            objFile
          );
          uploadAnswerRef.current.value = null;
        }
        // Clear input value
        e.target.value = null;
      } else {
        dispatch(
          showHideSnackbar({
            type: "error",
            isOpen: true,
            message: "Please select image"
          })
        );
      }
    }
  }
  async function handleOnSubmit(values, { resetForm }) {
    try {
      dispatch(showHideLoader(true));
      const editedForm = await Promise.all(
        values.map(async (quiz) => ({
          ...quiz,
          questions_attributes: await Promise.all(
            quiz.questions_attributes.map(async (question) => {
              // Process question image
              let updatedQuestion = { ...question };
              const file = question.image_url?.file;
              const name = question.image_url?.file?.name;

              if (file instanceof File && typeof name === "string") {
                const { link } = await uploadToS3(
                  "private",
                  file,
                  name
                );
                updatedQuestion.image_url = link;
              }

              // Process answer choices
              if (updatedQuestion.answer_choices_attributes) {
                updatedQuestion.answer_choices_attributes =
                  await Promise.all(
                    updatedQuestion.answer_choices_attributes.map(
                      async (answer) => {
                        const answerFile = answer.image_url?.file;
                        const answerName =
                          answer.image_url?.file?.name;

                        if (
                          answerFile instanceof File &&
                          typeof answerName === "string"
                        ) {
                          const { link } = await uploadToS3(
                            "private",
                            answerFile,
                            answerName
                          );
                          return { ...answer, image_url: link };
                        }
                        return answer;
                      }
                    )
                  );
              }

              return updatedQuestion;
            })
          )
        }))
      );

      // Await the dispatch if it's an async thunk
      await dispatch(
        importQuizzesToBookRequest({ quizzes: editedForm, book_id })
      );

      // Reset the form after successful submission
      resetForm();
      dispatch(setupQuizzesToBookResponce({ importedQuizzes: [] }));
    } catch (error) {
      console.error("Submission failed:", error);
      // Optionally reset the form even on failure
      resetForm();
    }
  }

  async function handleUploadImagesChange(e) {
    try {
      const selectedFiles = Array.from(e.target.files);
      if (!selectedFiles.length) {
        dispatch(
          showHideSnackbar({
            type: "error",
            isOpen: true,
            message: "No Files Selected."
          })
        );
        return;
      }

      let valuesForm = formRef.current.values;
      uploadAllImagesRef.current.value = null;
      // Create a Map for O(1) quiz lookups
      const quizMap = new Map(
        valuesForm.map((quiz) => [quiz.title.toLowerCase(), quiz])
      );

      // Process files in chunks to avoid blocking the main thread
      const processFiles = async (files) => {
        for (let i = 0; i < files.length; i += 10) {
          const chunk = files.slice(i, i + 10);
          await processChunk(chunk);
        }
      };

      const processChunk = async (chunk) => {
        await Promise.all(
          chunk.map(async (file) => {
            const fileName = file.name.split(".")[0];
            const [quizTitle, questionPart] = fileName.split("_");

            // Early return if filename format is invalid
            if (!quizTitle || !questionPart) {
              dispatch(
                showHideSnackbar({
                  type: "error",
                  isOpen: true,
                  message: `Invalid filename format: ${fileName}`
                })
              );
              // alert(`Invalid filename format: ${fileName}`);
              return;
            }

            // Get quiz from Map (O(1) lookup)
            const quiz = quizMap.get(quizTitle.toLowerCase());
            if (!quiz) {
              // alert(`No quiz found for file: ${fileName}`);
              dispatch(
                showHideSnackbar({
                  type: "error",
                  isOpen: true,
                  message: `No quiz found for file: ${fileName}`
                })
              );
              return;
            }

            // Process question or answer
            // if (answerPart) {
            //   await processAnswerImage(
            //     file,
            //     quiz,
            //     questionPart,
            //     answerPart
            //   );
            // } else {
            //   await processQuestionImage(file, quiz, questionPart);
            // }
            if (questionPart) {
              await processQuestionImage(file, quiz, questionPart);
            }
          })
        );
      };

      const processQuestionImage = async (
        file,
        quiz,
        questionPart
      ) => {
        const question = quiz.questions_attributes.find(
          (q, index) => index + 1 == questionPart.toLowerCase()
        );

        if (!question) {
          console.log(
            `No question found in quiz ${quiz.title} for file: ${file.name}`
          );
          return;
        }

        // Create URL only when needed
        const url = URL.createObjectURL(file);
        formRef.current.setFieldValue(
          `[${valuesForm.indexOf(
            quiz
          )}].questions_attributes[${quiz.questions_attributes.indexOf(
            question
          )}].image_url`,
          { file, url }
        );

        // Clean up URL when component unmounts
        return () => URL.revokeObjectURL(url);
      };

      // const processAnswerImage = async (
      //   file,
      //   quiz,
      //   questionPart,
      //   answerPart
      // ) => {
      //   const question = quiz.questions_attributes.find(
      //     (q) =>
      //       q.question.toLowerCase() === questionPart.toLowerCase()
      //   );

      //   if (!question) {
      //     console.log(
      //       `No question found in quiz ${quiz.title} for file: ${file.name}`
      //     );
      //     return;
      //   }

      //   const answerChoice = question.answer_choices_attributes.find(
      //     (a) => a.answer.toLowerCase() === answerPart.toLowerCase()
      //   );

      //   if (!answerChoice) {
      //     console.log(
      //       `No answer choice found for file: ${file.name}`
      //     );
      //     return;
      //   }

      //   const url = URL.createObjectURL(file);
      //   formRef.current.setFieldValue(
      //     `[${valuesForm.indexOf(
      //       quiz
      //     )}].questions_attributes[${quiz.questions_attributes.indexOf(
      //       question
      //     )}].answer_choices_attributes[${question.answer_choices_attributes.indexOf(
      //       answerChoice
      //     )}].image_url`,
      //     url
      //   );

      //   return () => URL.revokeObjectURL(url);
      // };

      await processFiles(selectedFiles);
    } catch (error) {
      console.error("Error handling file upload:", error);
    }
  }
  useEffect(() => {
    dispatch(getBooksRequest({ lookup: true }));
    return () =>
      dispatch(
        setupQuizzesToBookResponce({
          importedQuizzes: []
        })
      );
  }, []);

  useEffect(() => {
    if (book_id && formRef.current) {
      formRef.current.resetForm();
    }
  }, [book_id]);
  useEffect(() => {
    if (importedQuizzes?.length === 0 && formRef.current) {
      formRef.current.resetForm();
    }
  }, [importedQuizzes]);
  return (
    <div>
      <div className="mb-4">
        <Typography variant="h4" component="h1">
          {title}
        </Typography>
        <Typography variant="body1" component="h1">
          {note}
        </Typography>
      </div>
      <Formik initialValues={{}} enableReinitialize>
        {() => {
          return (
            <Form>
              <div className={styles.selectTitle}>
                <CustomSelect
                  options={books.map((book) =>
                    formatOptions(book, "id", "title")
                  )}
                  placeholder={"book"}
                  name="book_id"
                  bgColor={theme.palette.primary.light}
                  isRequired={true}
                  isMenuRelative={true}
                  isSearchable={true}
                  containerClass="mb-4"
                  handleSelectChange={(e) => {
                    setBookId(e);
                    dispatch(
                      setupQuizzesToBookResponce({
                        importedQuizzes: []
                      })
                    );
                  }}
                />
              </div>
            </Form>
          );
        }}
      </Formik>
      <div>
        <Button
          text={uploadFile}
          disabled={book_id ? false : true}
          icon={
            <UploadFileIcon
              className="mx-1"
              sx={{ fontSize: "18px", verticalAlign: "middle" }}
            />
          }
          onClick={handleImportQuizzes}
        />
        <input
          type="file"
          accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
          style={{ display: "none" }}
          ref={uploadRef}
          onChange={handleChange}
        />
      </div>
      {importedQuizzes?.errors?.length && (
        <div style={{ margin: "auto", width: "fit-content" }}>
          <Typography variant="h4" component="h1" color="error">
            {importedQuizzes.message}
          </Typography>
          <Typography variant="h6">{issue}</Typography>
          {importedQuizzes?.errors?.map((err, index) => (
            <>
              <p key={index}>{`${index + 1} : ${err}`}</p>
            </>
          ))}
        </div>
      )}

      {importedQuizzes?.length > 0 && (
        <div style={{ width: "100%", overflow: "auto" }}>
          <Formik
            innerRef={formRef}
            initialValues={importedQuizzes}
            enableReinitialize={true}
            onSubmit={handleOnSubmit}
            validationSchema={validtionOfSubmit}
            key={book_id} // Add this to force remount
          >
            {({ values, errors, setFieldValue }) => {
              return (
                <Form>
                  <TableContainer>
                    <Table>
                      <TableBody>
                        <FieldArray
                          name="imported_Quizzes"
                          render={() => {
                            return (
                              <>
                                {values?.map((Quiz, index) => (
                                  <React.Fragment key={Quiz.title}>
                                    <TableRow
                                      key={Quiz.title}
                                      className="w-100"
                                      onClick={() =>
                                        handleOpenCollaps(index)
                                      }
                                    >
                                      <TableCell>
                                        <IconButton
                                          aria-label="expand row"
                                          size="small"
                                          style={{
                                            position: "relative"
                                          }} // Add this
                                        >
                                          {openCollaps[index] ? (
                                            <KeyboardArrowUpIcon />
                                          ) : (
                                            <KeyboardArrowDownIcon />
                                          )}

                                          {/* Error message with absolute positioning */}
                                          {errors?.[index]
                                            ?.total_points && (
                                            <span
                                              className={`error ${styles.errorQuiz}`}
                                            >
                                              <ErrorIcon
                                                fontSize="small"
                                                sx={{
                                                  marginRight: "4px"
                                                }}
                                              />
                                              Issue Here
                                            </span>
                                          )}
                                        </IconButton>
                                      </TableCell>
                                      <TableCell align="right">
                                        <span
                                          style={{
                                            fontWeight: "bold"
                                          }}
                                        >
                                          title :
                                        </span>
                                        {` ${Quiz.title}`}
                                      </TableCell>
                                      <TableCell align="right">
                                        <span
                                          style={{
                                            fontWeight: "bold"
                                          }}
                                        >
                                          {totalPoints} :
                                        </span>
                                        {` ${Quiz.total_points}`}
                                      </TableCell>
                                    </TableRow>
                                    <TableRow className="table__row">
                                      <TableCell
                                        style={{
                                          paddingBottom: 0,
                                          paddingTop: 0
                                        }}
                                        colSpan={6}
                                      >
                                        <Collapse
                                          in={openCollaps[index]}
                                        >
                                          <div className="py-3">
                                            {errors?.[index]
                                              ?.total_points && (
                                              <div className="error mb-5">
                                                {
                                                  errors[index]
                                                    .total_points
                                                }
                                              </div>
                                            )}
                                            <Input
                                              name={`[${index}].book_page`}
                                              isRequired={true}
                                              label={"Page Number"}
                                              className={"w-25"}
                                              isNumber={true}
                                              type={"number"}
                                            />

                                            {Quiz
                                              ?.questions_attributes
                                              ?.length ? (
                                              Quiz?.questions_attributes?.map(
                                                (
                                                  question,
                                                  qIndex
                                                ) => {
                                                  return (
                                                    <div
                                                      key={qIndex}
                                                      className={
                                                        styles.question_container
                                                      }
                                                    >
                                                      <div
                                                        className={
                                                          styles.question_DIV1
                                                        }
                                                      >
                                                        <div
                                                          className={
                                                            styles.question_DIV2
                                                          }
                                                        >
                                                          <Typography variant="h6">
                                                            Q
                                                            {qIndex +
                                                              1}
                                                            :{" "}
                                                            {
                                                              question?.question
                                                            }
                                                          </Typography>
                                                          <Upload
                                                            ref={
                                                              uploadQuestionRef
                                                            }
                                                            onChange={(
                                                              e
                                                            ) =>
                                                              handleUploadSingleImage(
                                                                e,
                                                                index,
                                                                qIndex,
                                                                null,
                                                                "question"
                                                              )
                                                            }
                                                            label={`Image for Qustion ${
                                                              qIndex +
                                                              1
                                                            }`}
                                                            name={`[${index}].questions_attributes[${qIndex}].image_url`}
                                                            setFieldValue={
                                                              setFieldValue
                                                            }
                                                            accept="image/*"
                                                          />
                                                        </div>
                                                        {(() => {
                                                          return (
                                                            (question
                                                              .image_url
                                                              .url ||
                                                              question.image_url) && (
                                                              <div
                                                                className={
                                                                  styles.PreviewImages
                                                                }
                                                              >
                                                                <img
                                                                  src={
                                                                    question
                                                                      .image_url
                                                                      .url ||
                                                                    question.image_url
                                                                  }
                                                                  alt="image"
                                                                />
                                                                <CancelIcon
                                                                  className={
                                                                    styles.closeIcon
                                                                  }
                                                                  onClick={(
                                                                    e
                                                                  ) => {
                                                                    try {
                                                                      e.stopPropagation();
                                                                      setFieldValue(
                                                                        `[${index}].questions_attributes[${qIndex}].image_url`,
                                                                        ""
                                                                      );
                                                                      if (
                                                                        uploadQuestionRef.current
                                                                      ) {
                                                                        uploadQuestionRef.current.value =
                                                                          null;
                                                                      }
                                                                      const url =
                                                                        question
                                                                          .image_url
                                                                          .url ||
                                                                        question.image_url;
                                                                      if (
                                                                        url
                                                                      ) {
                                                                        URL.revokeObjectURL(
                                                                          url
                                                                        );
                                                                      }
                                                                    } catch (error) {
                                                                      console.error(
                                                                        "Error handling image removal:",
                                                                        error
                                                                      );
                                                                    }
                                                                  }}
                                                                />
                                                              </div>
                                                            )
                                                          );
                                                        })()}
                                                        <div>
                                                          {points} :
                                                          {
                                                            question.points
                                                          }
                                                        </div>
                                                      </div>

                                                      {question?.answer_choices_attributes?.map(
                                                        (
                                                          answer,
                                                          AIndex
                                                        ) => (
                                                          <div
                                                            key={
                                                              AIndex
                                                            }
                                                            className={
                                                              styles.answerContainer
                                                            }
                                                          >
                                                            <Typography variant="body1">
                                                              {AIndex +
                                                                1}
                                                              {") "}
                                                              {
                                                                answer?.answer
                                                              }
                                                            </Typography>
                                                            <Typography variant="body2">
                                                              {answer?.correct
                                                                ? "✅ Correct"
                                                                : "❌ Incorrect"}
                                                            </Typography>
                                                            <Upload
                                                              ref={
                                                                uploadAnswerRef
                                                              }
                                                              onChange={(
                                                                e
                                                              ) =>
                                                                handleUploadSingleImage(
                                                                  e,
                                                                  index,
                                                                  qIndex,
                                                                  AIndex,
                                                                  "answer"
                                                                )
                                                              }
                                                              label={`Image for Answer ${
                                                                AIndex +
                                                                1
                                                              }`}
                                                              name={`[${index}].questions_attributes[${qIndex}].answer_choices_attributes[${AIndex}].image_url`}
                                                              setFieldValue={
                                                                setFieldValue
                                                              }
                                                              accept="image/*"
                                                            />
                                                            {(() => {
                                                              return (
                                                                (answer
                                                                  .image_url
                                                                  .url ||
                                                                  answer.image_url) && (
                                                                  <div
                                                                    className={
                                                                      styles.PreviewImages
                                                                    }
                                                                  >
                                                                    <img
                                                                      src={
                                                                        answer
                                                                          .image_url
                                                                          .url ||
                                                                        answer.image_url
                                                                      }
                                                                      alt="image"
                                                                    />
                                                                    <CancelIcon
                                                                      className={
                                                                        styles.closeIcon
                                                                      }
                                                                      onClick={(
                                                                        e
                                                                      ) => {
                                                                        try {
                                                                          e.stopPropagation();
                                                                          setFieldValue(
                                                                            `[${index}].questions_attributes[${qIndex}].answer_choices_attributes[${AIndex}].image_url`,
                                                                            ""
                                                                          );
                                                                          if (
                                                                            uploadAnswerRef.current
                                                                          )
                                                                            uploadAnswerRef.current.value =
                                                                              "";
                                                                          const url =
                                                                            answer
                                                                              .image_url
                                                                              .url ||
                                                                            answer.image_url;
                                                                          URL.revokeObjectURL(
                                                                            url
                                                                          ); // Clean up memory
                                                                        } catch (e) {
                                                                          console.error(
                                                                            "Error handling image removal:",
                                                                            e
                                                                          );
                                                                        }
                                                                      }}
                                                                    />
                                                                  </div>
                                                                )
                                                              );
                                                            })()}
                                                          </div>
                                                        )
                                                      )}
                                                      <div
                                                        className={
                                                          styles.justificationDiv
                                                        }
                                                      >
                                                        <span
                                                          style={{
                                                            fontWeight:
                                                              "bold"
                                                          }}
                                                        >
                                                          Justification
                                                          :
                                                        </span>
                                                        {` ${question.justification}`}
                                                      </div>
                                                    </div>
                                                  );
                                                }
                                              )
                                            ) : (
                                              <div>AAAA</div>
                                            )}
                                          </div>
                                        </Collapse>
                                      </TableCell>
                                    </TableRow>
                                  </React.Fragment>
                                ))}
                              </>
                            );
                          }}
                        />
                      </TableBody>
                    </Table>
                  </TableContainer>
                  <div
                    style={{
                      marginTop: "10px"
                    }}
                  >
                    <Button
                      text={uploadQImages}
                      type={"button"}
                      style={{
                        display: "block",
                        marginBottom: "10px"
                      }}
                      onClick={() =>
                        uploadAllImagesRef.current.click()
                      }
                    />

                    <input
                      type="file"
                      accept="image/*"
                      style={{ display: "none" }}
                      ref={uploadAllImagesRef}
                      multiple
                      onChange={(e) => handleUploadImagesChange(e)}
                      webkitdirectory="true"
                      mozdirectory="true"
                      directory="true"
                    />
                    <Button text={submit} type={"submit"} />
                  </div>
                </Form>
              );
            }}
          </Formik>
        </div>
      )}
    </div>
  );
}

ImportQuiz.propTypes = {};

export default ImportQuiz;
